import { IntlType } from '../../../../utils/typing';

interface Props {
  intl: IntlType;
  handleClick: () => void;
}

const ConfirmButton = (props: Props): JSX.Element => {
  const { intl, handleClick } = props;

  return (
    <button className="confirm-button" onClick={handleClick}>
      {intl.formatMessage({ id: 'confirm' })}
    </button>
  );
};

export default ConfirmButton;
